import React from 'react'

export default function NotFound() {
    return (
        <div className="error">
            Página no encontrada
        </div>
    )
}
